import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUserStore } from '../../../components/userStore';

const CURR_YEAR = new Date().getFullYear();

const CompletedReportExport = () => {
	const { user } = useUserStore();
	const [year, setYear] = useState(new Date().getFullYear());
	const [month, setMonth] = useState(new Date().getMonth() + 1);
	const csvExportQuery = useQuery({
		queryKey: ['ilos-completed-csv', user.coord_agency.id, year, month],
		queryFn: async () => {
			const { data } = await axios.get(
				`/coord_agencies/${user.coord_agency.id}/ilos-completed-csv`,
				{
					params: {
						options: {
							year,
							month: month - 1,
						},
					},
				},
			);

			const url = window.URL.createObjectURL(new Blob([data.content]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', data.filename);
			document.body.appendChild(link);
			link.click();
			link.remove();

			return data;
		},
		enabled: false,
	});
	return (
		<>
			<div className="breadcrumbs">
				<ul>
					<li>
						<Link to="/" className="link">
							Home
						</Link>
					</li>
					<li>
						<Link to="/ilos-panel" className="link">
							Billing
						</Link>
					</li>
					<li>Completed Report Export</li>
				</ul>
			</div>
			<div className="clear-both px-4 py-4 mt-2 bg-white rounded-lg">
				<h2>Completed Report Export</h2>
				<div className="divider" />

				<div>
					<select
						className="select select-sm select-bordered"
						onChange={({ target }) => setMonth(target.value)}
						value={month}
					>
						<option value="1">January</option>
						<option value="2">February</option>
						<option value="3">March</option>
						<option value="4">April</option>
						<option value="5">May</option>
						<option value="6">June</option>
						<option value="7">July</option>
						<option value="8">August</option>
						<option value="9">September</option>
						<option value="10">October</option>
						<option value="11">November</option>
						<option value="12">December</option>
					</select>
					<select
						className="ml-2 select select-sm select-bordered"
						onChange={({ target }) => setYear(target.value)}
						value={year}
					>
						{Array.from({ length: 5 }, (_, i) => (
							<option key={i} value={CURR_YEAR - 2 + i}>
								{CURR_YEAR - 2 + i}
							</option>
						))}
					</select>
					<button
						className="ml-2 btn btn-sm btn-primary"
						onClick={csvExportQuery.refetch}
					>
						Export
					</button>
				</div>
			</div>
		</>
	);
};

export default CompletedReportExport;
